export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./delete-contact.vue?vue&type=template&id=5c974f88&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/delete-contact.vue?vue&type=template&id=5c974f88&
// module id = 1691
// module chunks = 0